import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators, FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ProjectMasterService } from "src/app/Service/projectmaster/projectmaster.service";
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { OrganizationService } from 'src/app/Service/organization/organization.service';
import { ProjectMemberLinkService } from 'src/app/Service/projectMemberLink/project-member-link.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { ChecklistModel, CopyChecklistModel } from 'src/app/ViewModel/ChecklistModel';
import { ChecklistService } from 'src/app/Service/checklist/checklist.service';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { CopyBulkChecklistResponseComponent } from '../Copy-Bulk-Checklist-Response/Copy-Bulk-Checklist-Response.components';

@Component({
    selector: 'app-Copy-Bulk-Checklist-dialog',
    templateUrl: './Copy_Bulk_Checklist.html'
})
export class CopyBulkChecklist implements OnInit {
    projStartDate = new Date();
    projEndDate = new Date();
    projectList: ProjectViewModel[] = [];
    businessGroups: BusinessGroupModel[] = [];
    FrombusinessGroups: BusinessGroupModel[] = [];
    TobusinessGroups: BusinessGroupModel[] = [];
    EnableSimProjForm!: FormGroup;
    selectedFromProject: any;
    public actionButtonText: string = "Submit";
    memberId!: number;
    ProjectID!:number|null;
    businessGroupId!:number |null;
    DisciplineId!:number | null;
    toprojectID!:number|null;
    tobusinessGroupId!:number|null;
    todisciplineId!:number|null;
    checkList: any|ChecklistModel[] = [];
    disciplineList: any|RoleFeatureModel[] = [];
    TodisciplineList: any| RoleFeatureModel[] = [];
    enablechkLstFilter =false;
    enablechkLstFullscreen  =false;
    public projectForm: FormGroup = new FormGroup({

        Fromproject: new FormControl(),
        Toproject: new FormControl(),
        TobusinessGroup: new FormControl(),
        FrombusinessGroup: new FormControl(),
        FromDiscipline: new FormControl(),
        ToDiscipline: new FormControl(),
    });

    constructor(private _projService: ProjectMasterService,
        public projectMemberLinkService: ProjectMemberLinkService, private _orgService: OrganizationService, private formBuilder: FormBuilder, private projectInfoService: ProjectInfoService, private _commonService: CommonService, 
        public _dialogRef: MatDialogRef<CopyBulkChecklist>,
        private _ResdialogRef: MatDialog,
        private _notificationService: NotificationService,
        public checklistService: ChecklistService,
        public mapRoleFeatureService: MapRoleFeatureService,
        @Inject(MAT_DIALOG_DATA) public _data: any) {

    }
    /**
     * ngOnInit - Angular Lifecycle hook
     */
    ngOnInit() {
        this.memberId = this._commonService.getLoggedInUserId();
       // if (!!this._data.project)
            this.setFormValues();

    }
     BUGlist()
     {
        this.projectForm.get('FrombusinessGroup')?.setValue("");
        if (this.ProjectID)
            this.projectMemberLinkService.getProjectBusinessGroup(this.ProjectID).subscribe((response: BusinessGroupModel[]) => {
                this.FrombusinessGroups = response.filter(each => each.is_Active);
           });
     }
     ToBUGlist()
     {
        this.projectForm.get('TobusinessGroup')?.setValue("");
        if (this.toprojectID)
            this.projectMemberLinkService.getProjectBusinessGroup(this.toprojectID).subscribe((response: BusinessGroupModel[]) => {
                this.TobusinessGroups = response.filter(each => each.is_Active);
           });
     }
    FromProjectChange(event: ProjectViewModel) {
        this.FrombusinessGroups=[];
        this.DisciplineId=this.ProjectID = this.businessGroupId = null;
        this.ProjectID = event.projectId ? Number(event.projectId) : null;
        this.projectForm.get('FrombusinessGroup')?.setValue(''); 
        this.projectForm.get('FromDiscipline')?.setValue('');       
        this.BUGlist();
        this.getCheckList();
                
       
    }

    FromBUChange(event: BusinessGroupModel) {
        this.disciplineList=[];
        this.businessGroupId = this.DisciplineId = null;
        this.projectForm.get('FromDiscipline')?.setValue('');        
        if(event.group_Id)
        {
            this.businessGroupId =  Number(event.group_Id);
            this.getDiscipline(this.businessGroupId);
        }
        this.getCheckList();
       
    }
    ToBuchange(event: BusinessGroupModel) {
        this.TodisciplineList=[];
        this.tobusinessGroupId = this.todisciplineId = null;
        this.projectForm.get('ToDiscipline')?.setValue('');
        if(event.group_Id)
        {
            this.tobusinessGroupId =  Number(event.group_Id);
            this.getToDiscipline(this.tobusinessGroupId);
        }
    }
    ToDisiplinechange(event:  RoleFeatureModel) {
        this.todisciplineId =null;
        if(event.dedId)
        this.todisciplineId = event.dedId ;
    }
    FromDisplineChange(event: RoleFeatureModel) {
        this.DisciplineId = null;
        if(event.dedId)
        {
            this.DisciplineId = Number(event.dedId) ;
        }
        this.getCheckList();
    }

    async ToProjectchange(event: ProjectViewModel) {
        this.TobusinessGroups =[];
        this.projectForm.get('TobusinessGroup')?.setValue("");  
        this.projectForm.get('ToDiscipline')?.setValue('');      
        this.todisciplineId = this.tobusinessGroupId = null;
        this.toprojectID = event.projectId ? Number(event.projectId) : null;                
        this.ToBUGlist();
       
    }

    /**
     * Set form values
     */
    setFormValues() {

        this.projectList = this._data.IprojectList;
        for (let i = 0; i < this.projectList.length; i++) {
            this.projectList[i]['projCodeDesc'] = this.projectList[i].projectCode + ' - ' + this.projectList[i].projectDescription;
        }
        

        this.ProjectID= this._commonService.getProjectId();
        this.selectedFromProject = this.projectList.filter(x => x.projectId == this.ProjectID)[0];
        //this.projectForm.get('Fromproject').setValue(this.selectedFromProject);
        this.FromProjectChange(this.selectedFromProject);
    }

    /**
     * Save project
     */
    savecopychecklist() {
        if (!this.ProjectID) {
			this._notificationService.showToast('Please select from project', 'Warning');
			return;
        }
        if (!this.toprojectID) {
			this._notificationService.showToast('Please select to project', 'Warning');
			return;
		}
        let selectedDocIds: number[] = this.checkList.filter((x: { is_select: any; }) => x.is_select).map((x: { clId: any; }) => x.clId);
        if (selectedDocIds.length<=0) {
			this._notificationService.showToast('Please select checklist', 'Warning');
			return;
		}
        let data: any| CopyChecklistModel = {
            fromProjectid: this.ProjectID,
            toProjectid: this.toprojectID,
            fromgroupId: this.businessGroupId,
            togroupId: this.tobusinessGroupId,
            fromdisciplineId: this.DisciplineId,
            todisciplineId: this.todisciplineId,
            cheklistid :selectedDocIds.toString(),
        };
        this.checklistService.postcopyChecklist(data).subscribe((data:any[]) => {
            if(data && data.length>0)
             this.Responce(data);
            //this._notificationService.handleResponse(data);
			//this.getCheckList();
		});
       
    }

    /**
     * Get GroupForm Controls value
     * @param controlName ControlName
     */
    getFormValue(controlName: string): any {
        return this.projectForm.get(controlName)?.value;
    }

    

    /**
     * Close modal dialog
     */
    closeDialog() {
        this._dialogRef.close();
    }
    async getCheckList() {
		if (!this.ProjectID && !this.businessGroupId && !this.DisciplineId) {
			this.checkList = [];
			return
		}

		this.checkList = await this.checklistService.getChecklist(this.businessGroupId, this.DisciplineId,null, null, this.ProjectID).toPromise();
    }
    async getDiscipline(businessGroupId: number) {
		if (!businessGroupId) {
			this.disciplineList = [];
			return;
        }
		this.disciplineList = await this.mapRoleFeatureService.getDedAgainstDe("Discipline", businessGroupId, null, null, 0).toPromise();
    }
    async getToDiscipline(businessGroupId: number) {
		if (!businessGroupId) {
			this.TodisciplineList = [];
			return;
        }
		this.TodisciplineList = await this.mapRoleFeatureService.getDedAgainstDe("Discipline", businessGroupId, null, null, 0).toPromise();
    }
    toggleFilter() {
        this.enablechkLstFilter = !this.enablechkLstFilter;
        
	}

	toggleChklstFullscreen() {
		this.enablechkLstFullscreen = !this.enablechkLstFullscreen
    }

    public onSelectionChange(event: Event | any): void {
        if (event['selectedRows'].length > 0) {
          event['selectedRows'].forEach((element: { dataItem: { is_select: boolean; }; }) => {
            element.dataItem.is_select = true;
          });
        }
        if (event['deselectedRows'].length > 0) {
          event['deselectedRows'].forEach((element: { dataItem: { is_select: boolean; }; }) => {
            element.dataItem.is_select = false;
          });
        }
      }

    public dataStateChange(state: any): void {
 
        this.checkList.map((x: { is_select: boolean; })=>x.is_select=false);
      }
    handleHeaderCheckboxEvent(event: any) {
        this.checkList.map((x: { is_select: any; }) => x.is_select = event.checked)
      }
      handleRowCheckboxEvent(event: any,rowIndex:number) {
        this.checkList[rowIndex].is_select=event.checked;
      }
      Responce(res: any[]) {
        let dialogRef = this._ResdialogRef.open(CopyBulkChecklistResponseComponent, {
          panelClass: 'mat-dialog-content',
          data: res
        });    
        dialogRef.afterClosed().subscribe((data) => {
            this.Reset();
        });
    
      }
      Reset()
      {
        this.checkList=[];
        this.projectForm.get('Fromproject')?.setValue('');
        this.projectForm.get('FrombusinessGroup')?.setValue('');
        this.projectForm.get('FromDiscipline')?.setValue('');
        this.projectForm.get('Toproject')?.setValue('');
        this.projectForm.get('TobusinessGroup')?.setValue('');
        this.projectForm.get('ToDiscipline')?.setValue('');
        this.ProjectID =null;
        this.toprojectID=null;
        this.businessGroupId=null;
        this.tobusinessGroupId=null;
        this.DisciplineId=null;
        this.todisciplineId=null;
        
      }
}